import BasicStyles from './BasicDetails.module.scss';
import EduStyles from './EducationDetails.module.scss';
import Styles from './WorkDetails.module.scss';

import Slide from '@mui/material/Slide';
import { TextField, FormControl, Autocomplete, Chip, FormHelperText } from '@mui/material';

// for strengths, skills and description
export function ExtraDetails({ profileData, handleInputChange, validation, props }) {

    const handleChange = (event, values) => {
        const skills = [...profileData.verified_tags, ...values]
        const uniqueValues = skills.filter(
            (tag, index, self) =>
                index === self.findIndex((t) => t.tag_name === tag.tag_name)
        );
        handleInputChange(uniqueValues, 'skills');
    };


    return (
        <>
            <Slide direction="left" in mountOnEnter unmountOnExit>
                <div id='eduFormContainer'
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div id='workForm' className={`${BasicStyles.nameForm} ${Styles.workForm}`}>
                        <p
                            id='subHeading'
                            className={`${BasicStyles.subHeading}`}
                        >
                            Highlights
                        </p>
                        <div
                            id='workBoxes'
                            className={`${BasicStyles.nameTextboxes} ${EduStyles.educationForm}`}
                        >

                            <FormControl
                                fullWidth
                                error={!validation.skills}
                            >
                                <Autocomplete
                                    multiple
                                    id="skills-select"
                                    limitTags={5}
                                    options={profileData?.tags}
                                    value={profileData.skills || []}
                                    onChange={handleChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Skills" fullWidth />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                        option.tag_name === value.tag_name
                                    }
                                    getOptionLabel={(option) => option.tag_name}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                key={index}
                                                label={option.tag_name}
                                                {...getTagProps({ index })}
                                                disabled={profileData?.verified_tags.includes(option)}
                                            />
                                        ))
                                    }
                                />

                                <FormHelperText>
                                    {!validation.skills ? 'Enter Your Skills Here' : 'Skills You Have Already Learned on AIVAGAM are marked by default'}
                                </FormHelperText>
                            </FormControl>
                            <TextField
                                error={!validation.strengths}
                                id={`strengths`}
                                label="Strengths"
                                placeholder="Mention 3 of Your Technical and Teamwork Strengths Here, separated by fullstops."
                                fullWidth={false}
                                helperText={!validation.strengths ? 'Enter Your Strength Here' : ' '}
                                multiline={true}
                                rows={3}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={profileData.strengths || ''}
                                onChange={(e) => handleInputChange(e.target.value, 'strengths')}
                            />
                            <TextField
                                error={!validation.description}
                                id={`description`}
                                label="Description"
                                placeholder="Give a short description of yourself"
                                fullWidth={false}
                                helperText={!validation.description ? 'Enter Your Description' : ' '}
                                multiline={true}
                                rows={3}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    maxLength: 300
                                }}
                                value={profileData.description || ''}
                                onChange={(e) => handleInputChange(e.target.value, 'description')}
                            />
                            <TextField
                                // error={!validation.projects}
                                id={`projects`}
                                label="Projects"
                                placeholder="Highlight your top 5 projects here(if any), separated by fullstops."
                                fullWidth={false}
                                // helperText={!validation.projects ? 'Enter Your Projects' : ' '}
                                multiline={true}
                                rows={3}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    maxLength: 30
                                }}
                                value={profileData.projects || ''}
                                onChange={(e) => handleInputChange(e.target.value, 'projects')}
                            />
                        </div>
                    </div>
                </div>
            </Slide >
        </>
    )

}
